// MARQUEE — editorial definition rows. Magazine-style: a big serif question on
// the left, the answer alongside on the right. No toggles, everything visible.
// Rows get a staggered entrance reveal.
function rowHtml(ctx, it) {
    return `<div class="fq-row"${ctx.reveal(it.idx)}>
  <h3 class="fq-q">${it.q}</h3>
  <div class="fq-a">${it.aHtml}</div>
</div>`;
}
const marquee = {
    id: 'marquee',
    name: 'Marquee',
    tag: 'Definition rows',
    styleTag: 'Editorial',
    description: 'Magazine-style definition rows \u2014 a big serif question on the left, the answer alongside. No toggles, all visible, beautifully readable.',
    layout: 'list',
    defaultAccent: '#0b2a46',
    darkDefault: false,
    catSupport: 'none',
    features: ['reveal'],
    render(ctx) {
        const html = `<div class="fq-wrap">
  <h2 class="fq-title">${ctx.title}</h2>
  ${ctx.subtitle ? `<p class="fq-sub">${ctx.subtitle}</p>` : ''}
  <div class="fq-rows">
${ctx.items.map((it) => rowHtml(ctx, it)).join('\n')}
  </div>
</div>`;
        const css = `
.FQM .fq-wrap{max-width:860px;margin:0 auto}
.FQM .fq-title{margin:0 0 8px;font-family:${ctx.v.head};font-size:44px;font-weight:550;line-height:1.05;letter-spacing:-0.015em;color:${ctx.v.ink}}
.FQM .fq-sub{margin:0 0 30px;font-family:${ctx.v.serif};font-size:15px;line-height:1.6;font-style:italic;color:${ctx.v.sub}}
.FQM .fq-row{display:flex;flex-wrap:wrap;gap:12px 40px;padding:28px 0;border-top:1px solid ${ctx.v.border}}
.FQM .fq-q{flex:1 1 240px;margin:0;font-family:${ctx.v.head};font-size:23px;font-weight:550;line-height:1.3;color:${ctx.v.ink}}
.FQM .fq-a{flex:2 1 320px;min-width:0;font-size:15.5px;line-height:1.7;color:${ctx.v.sub}}
`;
        return { html, css };
    },
};
export default marquee;
